// The async Clipboard API exists only in a secure context, and a phone opening the UI over plain
// http on the LAN has none, so the legacy copy command backs it up there and whenever the API
// rejects. [[spec-copyable-ui-values-and-end-to-end-coverage-of-the-web-flows]] R2

export async function copyText(text: string): Promise<boolean> {
    if (window.isSecureContext && typeof navigator.clipboard?.writeText === "function") {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            // Denied or unfocused: the legacy path may still be allowed.
        }
    }
    return legacyCopy(text);
}

function legacyCopy(text: string): boolean {
    const focused = document.activeElement;
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    // Off-screen rather than hidden: iOS will not select inside a `display: none` field.
    area.style.position = "fixed";
    area.style.top = "0";
    area.style.left = "-9999px";
    document.body.append(area);
    area.focus({ preventScroll: true });
    area.select();
    area.setSelectionRange(0, text.length);
    try {
        return document.execCommand("copy");
    } catch {
        return false;
    } finally {
        area.remove();
        if (focused instanceof HTMLElement) focused.focus();
    }
}
